const CONNECTING = 0;
const OPEN = 1;
const CLOSING = 2;
const CLOSED = 3;

let ws = null;
let ws_pending_message = null;
let incID = 0;
let ws_port_dictionary = {}

export const version = '2.1.15'
console.info(`ws_worker.js - version ${version}`)

let _ws_url = "";

if (location.protocol.toLowerCase() === 'https:') {
  _ws_url = "wss://" + location.host + "/websocket"
  console.info("")
}
else {
  _ws_url = "ws://" + location.host + "/websocket"
}

onmessage = function (e) {
  let obj = ''
  try {
    if ('data' in e) {
      obj = JSON.parse(e.data);
    } else {
      return;
    }
  } catch (ex) {
    console.error(`{"ws_worker: ${ex} ${e.data}`);
    return;
  }

  incID++;
  let port = e.ports[0];
  ws_port_dictionary[incID] = port;
  obj['id'] = incID;

  console.log('ws_worker: Message received from main script, e.data:' + e.data);

  if (ws == null) {
    wsopen();
  } else if (ws.readyState === CLOSED) {
    wsopen();
  }

  if (ws.readyState === OPEN) {
    console.time('ws_worker ' + obj['fn'])
    obj['__T0__'] = performance.now()
    let str_message = JSON.stringify(obj);

    ws.send(str_message);
    ws_pending_message = null;
    console.info('ws_worker: message sent: ' + str_message);
  } else {
    ws_pending_message = obj;
  }
}

function wsopen() {

  ws = new WebSocket(_ws_url);

  ws.onopen = function (e) {
    ws_onopen(e);
  }

  ws.onmessage = function (e) {
    ws_on_server_message(e);
  }

  ws.onclose = function (e) {
    ws_onclose(e);
  }

  ws.onerror = function (e) {
    ws_onerror(e);
  }
}

function ws_on_server_message(event) {
  let obj = JSON.parse(event.data);
  let delta;

  if ('id' in obj) {
    let id = obj.id;
    let port = ws_port_dictionary[id];
    let e = {};
    e.result = obj;
    e.error = false;
    if ('__T0__' in obj) {
      delta = performance.now() - obj.__T0__
      obj.__frnt__ = delta * 0.001
    }
    port.postMessage(e);
    delete ws_port_dictionary[id];
  } else {
    console.warn('missing ID in reply');
  }
  if ('fn' in obj) {
    console.timeEnd('ws_worker ' + obj['fn']);
  }

  if (obj.status == 4)
  {
    if ('reason' in obj) {
      if (obj.reason.includes('session'))
      {
        postMessage('invalid session');
      }
    }
  }
}

function ws_close() {
  if (ws == null) {
    console.warn('ws_close(): no active websocket');
    return;
  }
  ws.close();
  ws = null;
}

function ws_onopen(e) {

  if (ws_pending_message != null) {
    let str_message = JSON.stringify(ws_pending_message);
    ws.send(str_message);
    ws_pending_message = null;
  }
}

function ws_onclose(e) {
  console.info('ws_onclose');
  ws = null;
}

function ws_onerror(e) {
  console.info('ws_onerror');
  // ws = null;
}
